import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
    `<div>
  <h4>Description - Lift</h4>
  <p>
      Need for a team lift was reported by one of the Associates, who asked for help with lifting a heavy bag, package or cart.
  </p>
  <h4>Impact</h4>
  <p>
      Heavy lifts and Improper handling pose risks such as strains, sprains, and musculoskeletal injuries.
  </p>
  <h4>Resolution Steps</h4>
  <p>
      1. Locate the Stow Associate who requested help.<br />
      2. Assign additional support for the team lift.<br />
      3. After completing required steps, complete this work item in SCC.
  </p>
  <h4>Helpful Links</h4>
  <p>
      1. <span><a href="https://amazonprojects.corp.amazon.com/sites/AMZLACES2/processdocs/_layouts/15/WopiFrame.aspx?sourcedoc=%7B220615FF-F57C-4D1C-826F-6ECF60888BEF%7D&file=Pick%20Stage%20Lifting%20Technique%20PMV.pdf&action=default">Pick Stage Stow Bag Lifting Techniques (Second and Third Row)</a></span>
  </p>
</div>
`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/AMZLStations_Help_Request_Team_Lift.jsx